/**
 * Subscription API Client
 * TASK-04: Subscription API Integration
 *
 * API Endpoints:
 * - GET /api/subscriptions/me - Get current subscription
 * - GET /api/subscriptions/usage - Get usage statistics
 * - POST /api/subscriptions/change-plan - Change subscription plan
 */

import apiClient from './client';
import type {
  Subscription,
  SubscriptionUsage,
  ChangePlanRequest,
} from '@/types/subscription';

/**
 * Subscription API
 */
export const subscriptionApi = {
  /**
   * Get current user's subscription
   */
  getCurrentSubscription: async (): Promise<Subscription> => {
    const response = await apiClient.get<Subscription>('/api/subscriptions/me');
    return response.data;
  },

  /**
   * Get subscription usage statistics
   */
  getUsage: async (): Promise<SubscriptionUsage> => {
    const response = await apiClient.get<SubscriptionUsage>('/api/subscriptions/usage');
    return response.data;
  },

  /**
   * Change subscription plan
   */
  changePlan: async (request: ChangePlanRequest): Promise<Subscription> => {
    const response = await apiClient.post<Subscription>(
      '/api/subscriptions/change-plan',
      request
    );
    return response.data;
  },

  /**
   * Get DID numbers assigned to the organization
   */
  getDidNumbers: async (): Promise<DidNumberInfo[]> => {
    const response = await apiClient.get<DidNumberInfo[]>('/api/subscriptions/did-numbers');
    return response.data;
  },
};

export interface DidNumberInfo {
  did: string;
  status: string;
  routingType: string;
  isActive: boolean;
}
